import { inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpRequest
} from '@angular/common/http';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { KeycloakService } from './keycloak.service';
import { environment } from '../../environments/environment';
import { isPlatformAdministrationURL } from './portal-context';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak: KeycloakService = inject(KeycloakService);
  if (keycloak.getRealm() === 'master' && !isPlatformAdministrationURL(req.url, environment.userServiceUrl, window.location.origin)) {
    return next(req.clone({ headers: req.headers.delete('Authorization') }));
  }

  return from(keycloak.updateToken(30)).pipe(
    switchMap(() => next(addAuthorizationHeader(req, keycloak))),
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      return from(keycloak.updateToken(-1)).pipe(
        switchMap((refreshed) => {
          if (!refreshed) {
            keycloak.logout();
            return throwError(() => error);
          }

          return next(addAuthorizationHeader(req, keycloak));
        })
      );
    })
  );
};

function addAuthorizationHeader(req: HttpRequest<unknown>, keycloak: KeycloakService): HttpRequest<unknown> {
  const token = keycloak.getToken();

  if (!token) {
    return req;
  }

  return req.clone({
    setHeaders: {
      Authorization: `Bearer ${token}`
    }
  });
}
